import { render, staticRenderFns } from "./shopGoodPublish.vue?vue&type=template&id=d3127412&scoped=true"
import script from "./shopGoodPublish.vue?vue&type=script&lang=js"
export * from "./shopGoodPublish.vue?vue&type=script&lang=js"
import style0 from "./shopGoodPublish.vue?vue&type=style&index=0&id=d3127412&prod&lang=scss&scoped=true"
import style1 from "./shopGoodPublish.vue?vue&type=style&index=1&id=d3127412&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3127412",
  null
  
)

export default component.exports